import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AppAccesses } from "./accesses.ts";
import { AppComponents } from "./components.ts";

const AppFilters = {
  locator: { keys: ["name"] },
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type AppFilters = typeof AppFilters;

export const AppIconUrl =
  "https://raw.githubusercontent.com/ant-design/ant-design-icons/refs/heads/master/packages/icons-svg/svg/outlined/api.svg";

export const AppRegistration = Registration({
  accesses: AppAccesses,
  category: "resource",
  components: AppComponents,
  docs: { install: "custom-application" },
  filters: AppFilters,
  itemKind: "app",
  label: "Custom application",
  logoUrl: AppIconUrl,
  maturity: "preview",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("app", AppRegistration);
